import * as React from "react";

export interface SwitchProps
{
    disabled?: boolean;
    checked: boolean;
    onChange?: (value: boolean) => void;
}

export class Switch extends React.Component<SwitchProps, SwitchProps> {
    constructor(props:SwitchProps) {
        super( props );
		this.state = {
			checked: false
		}
    }
	
	componentWillMount () {
		this.setState( { checked: this.props.checked } );
	}

    render () {
        return(
            <div className="switch-container">
                <label>
                    <input ref="switch" disabled={this.props.disabled} checked={this.state.checked} onChange={() => this._handleChange()} className="switch" type="checkbox" />
                    <div>
                        <span><g className="icon icon-toolbar grid-view"></g></span>
                        <span><g className="icon icon-toolbar ticket-view"></g></span>
                        <div></div>
                    </div>
                </label>
            </div>
        );
    }

    _handleChange () {
		this.setState( { checked: !this.state.checked } );
        if (this.props.onChange) {
            this.props.onChange(this.state.checked);
        }
    }
}



// WEBPACK FOOTER //
// ./Scripts/React/Component/switch.tsx